<template>
    <footer>
        <div class="grid-x">
            <div class="cell auto" v-for="(item, index) in icons" :key="index" :class="{'active': activeStep === index}">
                <a @click="changeStep(index)">
                    <icon class="small-svg" :name="item.icon" />
                    <div v-if="item.counter > 0" class="counter">
                        <span>{{item.counter}}</span>
                    </div>
                    <p :class="{'custom-text': item.text.length > 13}">{{item.text}}</p>
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data () {
            return {
                activeStep: this.initStep
            }
        },
        props: [
            'initStep',
            'icons'
        ],
        methods: {
            changeStep (selectedStep) {
                this.activeStep = selectedStep
                this.$emit('changeStep', selectedStep)
            }
        }
    }
</script>

<style lang="scss">
.counter {
    background-color: #4d697c;
    border-radius: 50px;
    position: absolute;
    top: 12px;
    right: 10px;
    width: 20px;
    height: 20px;
    display: flex;
    text-align: center;
    justify-content: center;

    & span {
        margin-top: 0px;
        color: white;
        font-size: 0.8rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/nav/bottom-nav.vue